var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _g2, _g3, _g4, _g5, _g6, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBglogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 758,
    height: 464,
    viewBox: "0 0 758 464",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M492.387 376.391L489.885 374.953L0.0187988 93.754L5.01948 85.0448L492.382 364.808L631.006 285.125L491.07 203.171L454.274 225.101L451.726 223.639L150.619 50.9325L155.616 42.2205L454.18 213.469L491.03 191.507L651.02 285.206L492.387 376.391Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M491.051 289.044L406.546 240.877L451.718 214.933L456.718 223.643L426.763 240.844L491.041 277.484L562.856 236.498L676.022 172.049L680.992 180.775L567.829 245.224L491.051 289.044Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M488.499 278.937L414.107 322.804L419.209 331.455L493.6 287.588L488.499 278.937Z",
    fill: "#C5D3EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 136.761L5.03797 128.073L567.867 454.452L562.829 463.14L0 136.761Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M494.962 366.284L489.81 374.911L600.86 441.231L606.012 432.604L494.962 366.284Z",
    fill: "#C5D3EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M301.696 258.156L262.556 280.264L267.497 289.011L306.637 266.903L301.696 258.156Z",
    fill: "#C5D3EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M338.867 150.204L226.281 214.93L231.287 223.637L343.872 158.91L338.867 150.204Z",
    fill: "#C5D3EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M562.441 63.8158L376.931 172.067L381.993 180.741L567.503 72.4899L562.441 63.8158Z",
    fill: "url(#paint3_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M643.502 280.806L638.52 289.526L753.018 354.946L758 346.226L643.502 280.806Z",
    fill: "#C5D3EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M451.482 -7.3199e-06L262.561 106.391L267.488 115.142L456.41 8.75068L451.482 -7.3199e-06Z",
    fill: "url(#paint4_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M377.71 353.07L260.188 284.217L266.353 280.663L382.173 348.496L377.71 353.07Z",
    fill: "#FF9494"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M340.355 157.756L205.113 80.1979L208.188 74.8147L346.553 154.342L340.355 157.756Z",
    fill: "#FF9494"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M207.066 82.2898C209.45 82.2898 211.382 80.3576 211.382 77.974C211.382 75.5905 209.45 73.6582 207.066 73.6582C204.683 73.6582 202.75 75.5905 202.75 77.974C202.75 80.3576 204.683 82.2898 207.066 82.2898Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M207.067 80.1316C208.258 80.1316 209.224 79.1655 209.224 77.9737C209.224 76.7819 208.258 75.8158 207.067 75.8158C205.875 75.8158 204.909 76.7819 204.909 77.9737C204.909 79.1655 205.875 80.1316 207.067 80.1316Z",
    stroke: "#FF9494",
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M533.629 90.9213C536.012 90.9213 537.945 88.989 537.945 86.6055C537.945 84.2219 536.012 82.2897 533.629 82.2897C531.245 82.2897 529.313 84.2219 529.313 86.6055C529.313 88.989 531.245 90.9213 533.629 90.9213Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M533.629 88.7634C534.821 88.7634 535.787 87.7973 535.787 86.6055C535.787 85.4138 534.821 84.4476 533.629 84.4476C532.437 84.4476 531.471 85.4138 531.471 86.6055C531.471 87.7973 532.437 88.7634 533.629 88.7634Z",
    stroke: "#FF9494",
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M381.468 178.036L378.704 173.3L530.731 84.8347L533.495 89.5706L381.468 178.036Z",
    fill: "#FF9494"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M416.731 244.352L411.12 241.091L454.664 215.653L460.345 218.686L416.731 244.352Z",
    fill: "#FF9494"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M377.809 352.944L372.791 349.169L491.548 280.207L497.229 283.238L377.809 352.944Z",
    fill: "#FF9494"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M224.567 219.051L340.345 151.505L343.109 156.242L230.233 222.322L224.567 219.051Z",
    fill: "#FF9494"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M490.859 286.918L414.048 242.76L417.301 237.483L496.406 282.956L490.859 286.918Z",
    fill: "#FF9494"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M454.252 222.284L373.656 175.939L379.842 172.508L460.011 218.624L454.252 222.284Z",
    fill: "#FF9494"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M266.074 287.242L260.463 283.981L301.663 260.434L307.344 263.468L266.074 287.242Z",
    fill: "#FF9494"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M303.294 265.756L224.777 219.145L230.726 215.464L309.58 262.322L303.294 265.756Z",
    fill: "#FF9494"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M301.751 203.385L282.316 214.607L270.396 207.724L289.83 196.503L301.751 203.385Z",
    fill: "#C5D3EC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M326.87 188.842L307.436 200.064L295.516 193.181L314.95 181.96L326.87 188.842Z",
    fill: "#C5D3EC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M351.989 174.3L332.555 185.521L320.635 178.639L340.069 167.417L351.989 174.3Z",
    fill: "#C5D3EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M540.296 147.579V205.001L559.483 216.078V158.656L540.296 147.579Z",
    fill: "#BEC7D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M574.949 149.727L559.482 158.656V216.078L574.949 207.148V149.727Z",
    fill: "#6E7E8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M540.296 147.576L559.483 158.654L574.949 149.723L555.763 138.646L540.296 147.576Z",
    fill: "#AAB3BD"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M560.906 152.332V209.754L580.092 220.831V163.409L560.906 152.332Z",
    fill: "#BEC7D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M595.558 154.478L580.092 163.408V220.834L595.558 211.904V154.478Z",
    fill: "#6E7E8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M560.906 152.328L580.092 163.405L595.559 154.474L576.372 143.397L560.906 152.328Z",
    fill: "#AAB3BD"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M545.827 160.994V218.415L565.014 229.493V172.071L545.827 160.994Z",
    fill: "#BEC7D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M580.48 163.143L565.019 172.072V229.494L580.485 220.565L580.48 163.143Z",
    fill: "#6E7E8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M545.828 160.992L565.015 172.07L580.481 163.139L561.295 152.062L545.828 160.992Z",
    fill: "#AAB3BD"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.143 81.0298V111.803L449.29 124.014V93.2406L428.143 81.0298Z",
    fill: "#BEC7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.339 83.3966L449.292 93.2395V124.015L466.339 114.173V83.3966Z",
    fill: "#6E7E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.143 81.0253L449.29 93.2362L466.338 83.3932L445.185 71.1853L428.143 81.0253Z",
    fill: "#AAB3BD"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.046 68.193V131.491L415.193 143.702V80.4038L394.046 68.193Z",
    fill: "#BEC7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.245 70.5621L415.198 80.405V143.703L432.245 133.861V70.5621Z",
    fill: "#6E7E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.046 68.1915L415.194 80.4024L432.241 70.5595L411.094 58.3486L394.046 68.1915Z",
    fill: "#AAB3BD"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.952 87.8787V151.177L381.1 163.388V100.09L359.952 87.8787Z",
    fill: "#BEC7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.15 90.2469L381.102 100.09V163.388L398.15 153.545V90.2469Z",
    fill: "#6E7E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.952 87.8743L381.1 100.085L398.148 90.2365L377.001 78.0256L359.952 87.8743Z",
    fill: "#AAB3BD"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.785 36.5874V75.185L265.042 98.9665V60.3689L224.785 36.5874Z",
    fill: "#BEC7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.18 54.5579L264.79 60.5597V99.1559L275.186 93.1541L275.18 54.5579Z",
    fill: "#6E7E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.785 36.587L264.778 60.6117L275.174 54.6098L235.181 30.5852L224.785 36.587Z",
    fill: "#AAB3BD"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M217.828 125.558V188.857L238.976 201.067V137.769L217.828 125.558Z",
    fill: "#BEC7D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M256.026 127.927L238.979 137.769V201.068L256.026 191.225V127.927Z",
    fill: "#6E7E8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M217.829 125.554L238.976 137.765L256.025 127.916L234.878 115.706L217.829 125.554Z",
    fill: "#AAB3BD"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M187.766 144.997V183.594L228.022 207.376V168.778L187.766 144.997Z",
    fill: "#BEC7D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M238.16 162.968L227.771 168.969V207.566L238.166 201.564L238.16 162.968Z",
    fill: "#6E7E8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M187.767 144.997L227.76 169.021L238.155 163.019L198.162 138.995L187.767 144.997Z",
    fill: "#AAB3BD"
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M376.164 252.747V291.345L416.42 315.126V276.529L376.164 252.747Z",
    fill: "#BEC7D3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M426.558 270.718L416.169 276.72V315.316L426.564 309.314L426.558 270.718Z",
    fill: "#6E7E8D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M376.164 252.747L416.157 276.772L426.552 270.77L386.559 246.745L376.164 252.747Z",
    fill: "#AAB3BD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M320.26 106.212L300.826 117.433L288.905 110.551L308.339 99.3298L320.26 106.212Z",
    fill: "#C5D3EC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M469.654 321.712L450.22 332.933L438.3 326.051L457.734 314.829L469.654 321.712Z",
    fill: "#C5D3EC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M345.379 91.6695L325.945 102.891L314.024 96.0083L333.458 84.7872L345.379 91.6695Z",
    fill: "#C5D3EC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M494.773 307.169L475.339 318.39L463.419 311.508L482.853 300.286L494.773 307.169Z",
    fill: "#C5D3EC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M370.498 77.1264L351.064 88.3475L339.144 81.4652L358.578 70.2441L370.498 77.1264Z",
    fill: "#C5D3EC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M519.892 292.626L500.458 303.847L488.538 296.965L507.972 285.744L519.892 292.626Z",
    fill: "#C5D3EC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 195.97,
    y1: 200.618,
    x2: 168.304,
    y2: 136.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 575.879,
    y1: 236.513,
    x2: 594.166,
    y2: 177.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 228.425,
    y1: 262.93,
    x2: 230.248,
    y2: 259.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 383.651,
    y1: 174.634,
    x2: 496.624,
    y2: 224.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 266.25,
    y1: 110.733,
    x2: 285.719,
    y2: -20.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F1FF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBglogin);
export default __webpack_public_path__ + "static/media/bglogin.a15e70c88ee09546d6c25b828fe593c3.svg";
export { ForwardRef as ReactComponent };